import { formatCurrency } from '../../../lib/helpers/formatters';

const TotalRow = ({ total = 0, totalServices = 0 }) => (
  <tr className="summary-tr">
    <td>-</td>
    <td>-</td>
    <td>-</td>
    <td>-</td>
    <td className="txt-table-right">{formatCurrency(total)}</td>
    <td className="txt-table-right">{formatCurrency(totalServices)}</td>
  </tr>
);

export default TotalRow;
